import { render, staticRenderFns } from "./OrderComplain.vue?vue&type=template&id=7626491c&scoped=true&"
import script from "./OrderComplain.vue?vue&type=script&lang=ts&"
export * from "./OrderComplain.vue?vue&type=script&lang=ts&"
import style0 from "./OrderComplain.vue?vue&type=style&index=0&id=7626491c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7626491c",
  null
  
)

export default component.exports